<template>
  <div class="desktopOverlayContainer" v-if="this.menuItems.length > 0">
    <div class="topMenu">
      <div class="topMenuContent">
        <div
          class="menuItem"
          v-for="(menuItem, index) in menuItems"
          :key="index"
          @click="menuItemClikced(menuItem)"
        >
          {{ $t(validMenuItems[menuItem.type]) }}
        </div>
      </div>
      <fa-icon
        @click="toggleMenuCollapsed()"
        :icon="['fas', 'caret-left']"
        :style="menuCollapsed ? 'transform:rotate(180deg)' : ''"
      ></fa-icon>
    </div>
    <div class="SubMenus">
      <div
        ref="topicSubMenu"
        :class="
          'subMenuItem ' +
          (activeMenuItemId === 'topicSelection' ? 'active' : '')
        "
        v-if="menuItems.findIndex((x) => x.type === 'topicSelection') >= 0"
      >
        <div
          class="subMenuItemContent"
          v-for="(topic, index) in topicsData"
          :key="index"
          @click="topicClickEvent(topic)"
        >
          {{ topic.Title }} ({{ topic.start }}-{{ topic.end }})
        </div>
      </div>
      <div
        :class="
          'subMenuItem ' + (activeMenuItemId === 'pollContent' ? 'active' : '')
        "
        v-if="menuItems.findIndex((x) => x.type === 'pollContent') >= 0"
      >
        <div
          class="subMenuItemContent"
          v-for="(poll, index) in polls"
          :key="index"
          @click="pollClickEvent(poll)"
        >
          {{ poll.name }} ({{ poll.in }}-{{ poll.out }})
        </div>
      </div>
      <div
        :class="
          'subMenuItem ' +
          (activeMenuItemId === 'biographies-content' ? 'active' : '')
        "
        v-if="menuItems.findIndex((x) => x.type === 'biographies-content') >= 0"
      >
        <div
          class="subMenuItemContent"
          v-for="(faculty, index) in faculties"
          :key="index"
          @click="facultyClickEvent(faculty)"
        >
          {{ faculty.instanceData.name }}
        </div>
      </div>
      <div
        :class="
          'subMenuItem ' +
          (activeMenuItemId === 'resource-content' ? 'active' : '')
        "
        v-if="menuItems.findIndex((x) => x.type === 'resource-content') >= 0"
      >
        <div
          class="subMenuItemContent"
          v-for="(resource, index) in resources"
          :key="index"
          @click="resourceClickEvent(resource)"
        >
          {{ resource.instanceData.name }} ({{ resource.in }})
        </div>
      </div>
      <div
        :class="
          'subMenuItem ' +
          (activeMenuItemId === 'speakerPresentation' ? 'active' : '')
        "
        v-if="menuItems.findIndex((x) => x.type === 'speakerPresentation') >= 0"
      >
        <div
          class="subMenuItemContent"
          v-for="(presentation, index) in presentations"
          :key="index"
          @click="presentationClickEvent(presentation)"
        >
          {{ presentation.instanceData.title }} ({{
            presentation.instanceData.startTime
          }}-{{ presentation.instanceData.endTime }})
        </div>
      </div>
    </div>
    <div
      class="desktopTopicContainer"
      v-if="menuItems.findIndex((x) => x.type === 'topicSelection') >= 0"
    >
      <desktop-topic-container
        ref="topicData"
        :topicsData="topicsData"
      ></desktop-topic-container>
    </div>
  </div>
</template>
<script>
import "../scss/desktop-video-overlay.css";
import pollClikcedMixin from "../mixins/pollClickedMixin";
import timeMixin from "../mixins/timeMixin";
import desktopTopicContainer from "./desktop-topic-content.vue";

import { LoadDesktopTopicDataFromGoogleSheet } from "../general-functions";
export default {
  props: {
    overlayContent: {
      type: Object,
      required: false,
    },
  },
  components: {
    desktopTopicContainer,
  },
  methods: {
    menuItemClikced(item) {
      switch (item.type) {
        case "transcriptContent":
          window.dispatchEvent(new CustomEvent("transcriptDisplayEvent"));
          break;
        case "slide-content":
          this.initialPrefs.isSlideVisible = !this.initialPrefs.isSlideVisible;
          break;
        case "custom-link":
          window.dispatchEvent(new CustomEvent("openLink", {
            detail: {
              routeLink: this.customLink[0].instanceData.link,
              alertText: this.customLink[0].instanceData.alertText
                ? this.customLink[0].instanceData.alertText
                : null
            }
          }));
          break;
        default:
          if (this.activeMenuItemId === item.type) {
            this.activeMenuItemId = "";
            window.removeEventListener("mousedown", this.hideMenuItem);
          } else {
            this.activeMenuItemId = item.type;
            window.addEventListener("mousedown", this.hideMenuItem);
          }
          break;
      }
    },
    pollClickEvent(poll) {
      this.pollClicked(
        poll.title,
        poll.navigateTime
          ? this.convertHoursMinsSecsToSeconds(poll.navigateTime)
          : this.convertHoursMinsSecsToSeconds(poll.in)
      );
      this.activeMenuItemId = "";
    },
    hideMenuItem(e) {
      let menuSubItem = e.target.closest(".SubMenus");
      let menuItem = e.target.closest(".menuItem");
      if (menuSubItem == null && menuItem == null) {
        this.activeMenuItemId = "";
      }
      window.removeEventListener("mousedown", this.hideMenuItem);
    },
    presentationClickEvent(presentation) {
      this.$root.$emit(
        "seekVideo",
        presentation.instanceData.navigateTime
          ? this.convertHoursMinsSecsToSeconds(
              presentation.instanceData.navigateTime
            )
          : this.convertHoursMinsSecsToSeconds(
              presentation.instanceData.startTime
            )
      );
      if (presentation.instanceData.summaryFile != null) {
        this.$root.$emit("pauseVideo");
        let customEvent = new CustomEvent("openDesktopOverlay", {
          detail: {
            state: "clicked",
            data: {
              isFullScreen: true,
              items: [
                {
                  instanceData: presentation.instanceData,
                },
              ],
            },
            component: "speakerPresentation",
          },
        });
        window.dispatchEvent(customEvent);
      } else {
        this.$root.$emit("playVideo");
      }
      this.activeMenuItemId = "";
    },
    resourceClickEvent(resource) {
      this.$root.$emit(
        "seekVideo",
        resource.navigateTime
          ? this.convertHoursMinsSecsToSeconds(resource.navigateTime)
          : this.convertHoursMinsSecsToSeconds(resource.in)
      );
      this.$root.$emit("playVideo");
      this.activeMenuItemId = "";
    },
    toggleMenuCollapsed() {
      this.menuCollapsed = !this.menuCollapsed;
    },
    topicClickEvent(topic) {
      this.$refs.topicData.openTopic(topic.Title);
      this.activeMenuItemId = "";
    },
    runMethods(time) {
      if (this.$refs.topicData) this.$refs.topicData.runMethods(time);
    },
    facultyClickEvent(faculty) {
      let customEvent = new CustomEvent(
        faculty.instanceData.buttonType + "ButtonEvent",
        {
          detail: {
            state: "clicked",
            data: faculty.instanceData,
          },
        }
      );
      window.dispatchEvent(customEvent);
      this.activeMenuItemId = "";
    },
  },
  async created() {
    if (this.overlayContent.menu == null) return;
    this.menuItems = this.overlayContent.menu.filter((item) => {
      return (
        Object.keys(this.validMenuItems).findIndex((x) => x === item.type) >= 0
      );
    });
    let topicSelectionIndex = this.menuItems.findIndex(
      (x) => x.type === "topicSelection"
    );
    if (topicSelectionIndex != -1) {
      this.topicsData = await LoadDesktopTopicDataFromGoogleSheet(
        this.menuItems[topicSelectionIndex].data.sheetsURL
      );
    }
  },
  data() {
    return {
      menuItems: [],
      pollData: [],
      resourcesData: [],
      menuCollapsed: true,
      activeMenuItemId: "",
      topicsData: [],
    };
  },
  computed: {
    polls: function () {
      return this.overlayContent.overlays.filter(
        (x) => x.parentItemType === "audiencePoll"
      );
    },
    resources: function () {
      return this.overlayContent.overlays.filter(
        (x) => x.parentItemType === "resourceButton"
      );
    },
    presentations: function () {
      return this.overlayContent.overlays.filter(
        (x) => x.parentItemType === "speakerPresentation"
      );
    },
    faculties: function () {
      return this.overlayContent.overlays.filter(
        (x) => x.parentItemType === "faculty"
      );
    },
    customLink: function () {
      return this.overlayContent.overlays.filter(
        (x) => x.parentItemType === "customLink"
      );
    },
    validMenuItems: function () {
      return {
        topicSelection: "Topics",
        pollContent: "Polls",
        "resource-content": "Resources",
        speakerPresentation: "Speaker Presentations",
        "biographies-content": "Biographies",
        "custom-link": "Evaluation",
        "slide-content": this.initialPrefs.isSlideVisible
          ? "Hide Slide"
          : "Show Slide",
        transcriptContent: this.initialPrefs.showDesktopTranscript
          ? "Hide Transcript"
          : "Show Transcript",
      };
    },
  },
  mixins: [pollClikcedMixin, timeMixin],
};
</script>

<style>
</style>
